import {Observable, throwError as observableThrowError}                          from 'rxjs';
import {Injectable}                                                              from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Router}                                                                  from '@angular/router';

import {catchError}      from 'rxjs/operators';
import {SnackbarService} from '../services/snackbar.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private snackBarService: SnackbarService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(catchError((err: HttpErrorResponse) => {
            switch (err.status) {
                case 400:
                    return observableThrowError(err.error);
                case 401:
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    break;
                default:
                    if (err.message != '' || err.message != null)
                        this.snackBarService.addMessage(err.message);
                    else
                        this.snackBarService.addMessage('Oups an error occurred');
                    break;
            }
        }));
    }
}
